import { useEffect, useState } from "react";

const BusinessCalculatorShow = () => {
  const [revenue, setRevenue] = useState(0);
  const [expenses, setExpenses] = useState(0);
  const [profit, setProfit] = useState(0);

  useEffect(() => {
    setProfit(revenue - expenses);
  }, [revenue, expenses]);

  return (
    <div>
      <h1>Business Calculator</h1>
      <label>Revenue</label>
      <input
        type="number"
        value={revenue}
        onChange={(e) => setRevenue(Number(e.target.value))}
      />
      <label>Expenses</label>
      <input
        type="number"
        value={expenses}
        onChange={(e) => setExpenses(Number(e.target.value))}
      />
      <h2>Profit: {profit}</h2>
    </div>
  );
};

export default BusinessCalculatorShow;
